import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {CartLineDAO} from "@app/core/cart/infrastructure/cart-line.DAO";

/**
 * This class is used to notify the quantity of the cart when it changes.
 */
@Injectable({
    providedIn: "root"
})
export class CartQuantityNotifier {

    private cartQuantitySubject = new BehaviorSubject<number>(0);
    /**
     * Observable that emits the quantity of the cart when it changes.
     * If the cart is not initialized yet, emits the value 0
     */
    readonly cartQuantity$ = this.cartQuantitySubject.asObservable();

    constructor(
        private cartLineDAO: CartLineDAO
    ) {
        // Since the initial value of the subject is an arbitrary value,
        // this method should be called here to overwrite the fake value sent
        this.notifyCartQuantityChanged();
    }

    /**
     * Each time an cartLine is added, updated or removed this function should be called 
     */
    public async notifyCartQuantityChanged(): Promise<void> {
        let total = 0;

        const allCartLines = await this.cartLineDAO.findAll();
        if (allCartLines.length) {
            total = allCartLines
                .map(
                    cartLine => cartLine.quantity
                )
                .reduce(
                    (previous, current) => { return previous + current }
                );

        }

        this.cartQuantitySubject.next(total);
    }
}
